module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/13r8Lce/tc-custom/9781426846878.jpg?1728954683777",
      "alt": "This image is the cover for the book High Plains Bride, After the Storm: The Founding Years"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("High Plains Bride, After the Storm: The Founding Years\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Emmeline Carter was prepared for danger on the new frontier. But she didn't foresee the tornado that tore their wagon train apart. Now her father is dead, her mother and sister are injured and their twin wards are missing. There's nowhere to turn but the fledgling Kansas settlement of High Plains. Town founder Will Logan steps in to search for the twins and house the Carters…for now. He's not cut out for family life long-term. But Emmeline's got her own ideas, and when this high plains bride chooses her groom, nothing will get in her way!"), _c('br'), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Valerie Hansen\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Valerie Hansen resides in the rural Ozarks where she writes the books of her heart, primarily for Love Inspired Romance and Suspense. She is married to her childhood sweetheart and has worked as a teacher's-aide, EMT, fire dept. dispatcher, dog breeder, commercial artist, dulcimer builder, Veterinarian's asst., 4-H leader, Sunday School teacher, antique restorer and certified Storm Spotter, etc. See ValerieHansen.com for more!")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0